module.exports = __webpack_public_path__ + "static/media/backpack.5d9de53b.svg";